import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { faChartLineUp } from '@fortawesome/pro-solid-svg-icons/faChartLineUp';
import { faMegaphone } from '@fortawesome/pro-solid-svg-icons/faMegaphone';
import { faSackDollar } from '@fortawesome/pro-solid-svg-icons/faSackDollar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/pro-solid-svg-icons/faSquare';
import { SmartlinksMusicMarketingBox } from '../SmartlinksMusicMarketingBox';
import { nextAsset } from '../../../../components/nextAsset';
import { PlaylistsSharingGetAccessButton } from '../../playlistsSharing/PlaylistsSharingGetAccessButton';

export const SmartlinksMarketingRelease: React.FC = () => {
  const intl = useIntl();

  return (
    <div className="smartlinks-music-marketing py-5">
      <Container className="py-5">
        <Row>
          <Col>
            <h2 className="main-header text-center pt-5 pb-3 text-secondary">
              {intl.formatMessage({
                id: 'sml.web.smartlinks.release.music-marketing.title',
                defaultMessage: 'Get crucial fan and streaming insights'
              })}
            </h2>
            <p className="main-header-subtitle text-center">
              {intl.formatMessage({
                id: 'sml.web.smartlinks.release.music-marketing.drive-streams.title',
                defaultMessage: "Know who your fans are, where they're coming from, and their preferred destinations."
              })}
            </p>
          </Col>
        </Row>
        <Row className="align-items-stretch py-5">
          <SmartlinksMusicMarketingBox icon={faMegaphone}>
            {intl.formatMessage(
              {
                id: 'sml.web.smartlinks.release.music-marketing.box1',
                defaultMessage: 'Collect valuable <b>data</b> about your audience'
              },
              {
                b: (str: React.ReactNode[]) => <strong className="text-uppercase text-secondary">{str}</strong>
              }
            )}
          </SmartlinksMusicMarketingBox>
          <SmartlinksMusicMarketingBox icon={faChartLineUp}>
            {intl.formatMessage(
              {
                id: 'sml.web.smartlinks.release.music-marketing.box2',
                defaultMessage: 'Track the <b>PERFORMANCE</b> of your campaigns'
              },
              {
                b: (str: React.ReactNode[]) => <strong className="text-uppercase text-secondary">{str}</strong>
              }
            )}
          </SmartlinksMusicMarketingBox>
          <SmartlinksMusicMarketingBox icon={faSackDollar}>
            {intl.formatMessage(
              {
                id: 'sml.web.smartlinks.release.music-marketing.box3',
                defaultMessage: '<b>Optimize</b> your marketing efforts'
              },
              {
                b: (str: React.ReactNode[]) => <strong className="text-uppercase text-secondary">{str}</strong>
              }
            )}
          </SmartlinksMusicMarketingBox>
        </Row>
      </Container>
      <div className="smartlinks-brand bg-primary">
        <Container className="py-5">
          <Row>
            <Col xs={12} className="d-flex d-lg-none justify-content-center">
              <img src={nextAsset('images/smartLinks/artist/brand.png')} alt="MR eazi brand" className="img-fluid" />
            </Col>
            <Col>
              <h2 className="main-header pt-5 pb-3 text-white text-center text-lg-start">
                {intl.formatMessage({
                  id: 'sml.web.smartlinks.release-effort.title',
                  defaultMessage: 'Maximum impact from minimum effort'
                })}
              </h2>
              <p className="header-subtitle">
                {intl.formatMessage({
                  id: 'sml.web.smartlinks.release-effort.description',
                  defaultMessage: 'Share your music easier than ever before, with less manual work.'
                })}
              </p>
              <ul className="fa-ul pt-5">
                <li className="lead text-white pb-4">
                  <span className="fa-li text-secondary">
                    <FontAwesomeIcon icon={faSquare} />
                  </span>
                  {intl.formatMessage({
                    id: 'sml.web.smartlinks.artist.release-brand.streaming',
                    defaultMessage:
                      'Paste one link to your music on any major streaming service and we’ll automatically find the same release on all the major music platforms'
                  })}
                </li>
                <li className="lead text-white pb-4">
                  <span className="fa-li text-secondary">
                    <FontAwesomeIcon icon={faSquare} />
                  </span>
                  {intl.formatMessage({
                    id: 'sml.web.smartlinks.artist.release-brand.automatically',
                    defaultMessage: 'Automatically generate a sleek microsite for your next release'
                  })}
                </li>
                <li className="lead text-white pb-4">
                  <span className="fa-li text-secondary">
                    <FontAwesomeIcon icon={faSquare} />
                  </span>
                  {intl.formatMessage({
                    id: 'sml.web.smartlinks.artist.release-brand.Share',
                    defaultMessage: 'Share your Smart Links instantly across the web and social media'
                  })}
                </li>
              </ul>
              <div className="d-flex justify-content-center justify-content-lg-start ps-4">
                <PlaylistsSharingGetAccessButton
                  className="text-white text-center align-items-center"
                  isHighlighted
                  source="Release Page Marketing"
                />
              </div>
            </Col>
            <Col className="d-none d-lg-block pt-5">
              <img src={nextAsset('images/smartLinks/artist/brand.png')} alt="Mr Eazi brand" className="img-fluid" />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};
